import React from "react";

const EventListExample = (props) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const orientation = urlParams.get("orientation");
  const align = urlParams.get("align");
  const color = urlParams.get("color");

  return (
    <div class="event_list_wrapper ">
      <div class={"event_list " + `${orientation} ${align}`}>
        <ul>
          <li>
            <div class="event_list_container">
              <div class={"event_list_content " + color}>
                <div class={"event_list_icon reward " + color}></div>
                <h1>$20 Steve</h1>
                <div class="incentive_claimed_wrapper">
                  <span>
                    <span>
                      <span class="incentive_claimed">Reward </span>Googly eye
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="event_list_container">
              <div class="event_list_content">
                <div class="event_list_icon reward"></div>
                <h1>$100 Richard</h1>
                <div class="incentive_claimed_wrapper">
                  <span>
                    <span>
                      <span class="incentive_claimed">Reward </span>Sip of Water
                    </span>
                  </span>
                  <span>
                    <span class="incentive_claimed">Poll</span> I like it
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="event_list_container">
              <div class="event_list_content">
                <div class="event_list_icon poll"></div>
                <h1>$1 Dave</h1>
                <div class="incentive_claimed_wrapper">
                  <span>
                    <span class="incentive_claimed">Poll</span> I don't like it
                  </span>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="event_list_container">
              <div class="event_list_content">
                <div class="event_list_icon donation"></div>
                <h1>$10 Brian</h1>
              </div>
            </div>
          </li>
          <li>
            <div class="event_list_container">
              <div class="event_list_content">
                <div class="event_list_icon reward"></div>
                <h1>$135 Susan</h1>
                <div class="incentive_claimed_wrapper">
                  <span>
                    <span>
                      <span class="incentive_claimed">Reward </span>Googly eye
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default EventListExample;
